import { Link } from '@mui/material';

import CenteredScreen from '@/karehero-app/onboarding/current-flow/CenteredScreen';
import { AI_CONSENT } from '@/karehero-app/tell-us-once/intake/content';
import { type Account } from '@/karehero-app/access/AccountBar';

/**
 * The AI processing consent, shown once between "You're in" and the first
 * question. Same template as the screen before it, so it reads as the next beat
 * of onboarding rather than a legal gate bolted on.
 *
 * Two actions rather than one Continue: the flow asks for a word dump and reads
 * it with a model, and a consent that cannot be refused is a notice wearing a
 * consent's clothes.
 *
 * The blurb is the template's own description, so it sits under the heading in
 * the same place the screen before it puts its description, and the two read as
 * one flow. It was a dashed placeholder box floating in the middle, which put
 * the buttons somewhere different from every other screen.
 */
const AiConsentScreen = ({
  onAccept,
  onDecline,
  account,
  content = AI_CONSENT,
}: {
  onAccept: () => void;
  /** The words. Onboarding 1.1 has its own, plainer about what AI is for. */
  content?: typeof AI_CONSENT;
  onDecline: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <CenteredScreen
    account={account}
    title={content.title}
    description={content.body}
    note={
      <>
        {content.policyLead}{' '}
        <Link component='button' type='button' variant='subtitle1'>
          {content.policyLink}
        </Link>
      </>
    }
    actions={[
      { label: content.accept, variant: 'primary', onClick: onAccept },
      { label: content.decline, variant: 'secondary', onClick: onDecline },
    ]}
  />
);

export default AiConsentScreen;
